import { render, staticRenderFns } from "./CurrentBillingsStats.vue?vue&type=template&id=105f6813&scoped=true"
import script from "./CurrentBillingsStats.vue?vue&type=script&lang=js"
export * from "./CurrentBillingsStats.vue?vue&type=script&lang=js"
import style0 from "./CurrentBillingsStats.vue?vue&type=style&index=0&id=105f6813&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105f6813",
  null
  
)

export default component.exports